// SVG geometry retained under the MIT license in LICENSE.txt.
import React from 'react';
import { SvgIcon } from '../primitives';
const Remove = React.forwardRef(function Remove(props, ref) {
    return <SvgIcon {...props} ref={ref}><path d="M19 13H5v-2h14v2z"/></SvgIcon>;
});
export default Remove;
